// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__zjPTn","black":"siteholder_black__faGDF","white":"siteholder_white__z9rlL","img":"siteholder_img__cI86G","zoomin":"siteholder_zoomin__D8ipw"};